<template>
  <div class="spinner-parent">
    <spinner ref="sourceSpinner" size="md" text="Loading ..." />
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>Edit Editor's Picks For Documents</h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>Add new Document</strong>
        </div>

        <div class="card-block">
          <div class="row images-dd__wrap">
            <div class="col-md-6 spinner-parent">
              <div class="images-dd__target-zone">
                <div class="images-dd__target-zone__title">
                  Documents for Editors Picks:
                </div>
                <div class="editors-picks__list">
                  <div v-if="!selectedPicks.length && !isLoading" class="images-dd__list--empty">
                    Please select items to add
                  </div>
                  <div
                    v-for="item in selectedPicks"
                    :key="item.id"
                    class="editors-picks__pick-item"
                    :data-id="item.id"
                    :title="item.title"
                  >
                    <div class="editors-picks__title">
                      <strong>{{ item.title || 'No Title' }}</strong>
                    </div>
                    <div class="editors-picks__text" :title="item.title">
                      {{ adaptText(item.body) || 'No description' }}
                    </div>
                    <div class="editors-picks__cover" @click="deleteEditorsPick(item)">
                      <i class="fa fa-minus" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="images-dd__source-wrap spinner-parent">
                <div class="editors-picks__search">
                  <input
                    v-model="searchQuery"
                    type="text"
                    class="form-control"
                    placeholder="Search by document title or url"
                  >
                </div>
                <nav>
                  <pager
                    :total="total"
                    :offset="offset"
                    :size="perPage"
                    @page-changed="onPageChanged"
                  />
                </nav>

                <div class="spinner-parent">
                  <div class="editors-picks__list editors-picks__list_with-search">
                    <div
                      v-for="item in filteredPicks"
                      :key="item.id"
                      class="editors-picks__pick-item"
                      :data-id="item.id"
                      :title="item.title"
                    >
                      <div class="editors-picks__title" :title="item.title">
                        <strong>{{ item.title || 'No Title' }}</strong>
                      </div>
                      <div class="editors-picks__text" :title="item.title">
                        {{ adaptText(item.body) || 'No description' }}
                      </div>
                      <div class="editors-picks__cover" @click="addEditorsPick(item)">
                        <i class="fa fa-plus" />
                      </div>
                    </div>

                    <div v-if="!filteredPicks.length && !isLoading" class="images-dd__list--empty">
                      There are no items for your request
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success" @click="save">
          Save Picks
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Editor's Picks have saved successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Pager from '@/global/components/Pager';

export default {
  name: 'EditorsPicksEdit',

  components: {
    pager: Pager,
  },

  data() {
    return {
      picks: [],
      selectedPicksSet: new Set(),
      unpickedSet: new Set(),
      saveErrorMessage: 'Error in data saving',
      searchQuery: '',
      isLoading: false,
      total: 0,
      offset: 0,
      perPage: null,
    };
  },

  computed: {
    selectedPicks() {
      return Array.from(this.selectedPicksSet);
    },
    unpickedPicks() {
      return Array.from(this.unpickedSet);
    },
    emptySearch() {
      return !!this.searchQuery;
    },
    filteredPicks() {
      const arr = [...this.picks];
      _.remove(arr, (item) => {
        if (this.selectedPicks.find(pick => pick.id === item.id)) {
          return true;
        }
        return false;
      });
      return arr;
    },
  },

  watch: {
    searchQuery: _.debounce(function () {
      this.offset = 0;
      this.getPicks();
    }, 400),
    offset() {
      this.getPicks();
    },
  },

  mounted() {
    this.getPicksAndSelectedData();
  },

  methods: {
    addEditorsPick(pick) {
      this.selectedPicksSet.add(pick);
      this.selectedPicksSet = new Set(this.selectedPicksSet);
      const unpickedPick = this.unpickedPicks.find(item => item.id === pick.id);
      if (unpickedPick) {
        this.unpickedSet.delete(unpickedPick);
        this.unpickedSet = new Set(this.unpickedSet);
      }
    },
    deleteEditorsPick(pick) {
      const selectedPick = this.selectedPicks.find(item => item.id === pick.id);
      if (!selectedPick) {
        return;
      }
      this.selectedPicksSet.delete(selectedPick);
      this.selectedPicksSet = new Set(this.selectedPicksSet);
      this.unpickedSet.add(pick);
      this.unpickedSet = new Set(this.unpickedSet);
    },
    getPicks() {
      if (this.$refs.sourceSpinner) { this.$refs.sourceSpinner.show(); }
      const searchProcessId = Math.random();
      const searchString = encodeURI(this.searchQuery);
      const page = this.perPage ? (this.offset / this.perPage + 1) : 1;
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(`${this.$config.app_api.prefix}media/documents`, {
        params: {
          search_string: searchString,
          page,
        },
      }).then((response) => {
        if (this.searchProcessId === searchProcessId) {
          const picks = _.cloneDeep(response.data);
          this.total = response.data.meta.pagination.total;
          this.perPage = response.data.meta.pagination.per_page;
          delete picks.meta;
          this.picks = Object.keys(picks).map(e => picks[e]);
        }
        if (this.$refs.sourceSpinner) { this.$refs.sourceSpinner.hide(); }
      }).catch((error) => {
        if (this.$refs.sourceSpinner) { this.$refs.sourceSpinner.hide(); }
        console.error(error);
      });
    },
    getPicksAndSelectedData() {
      if (this.$refs.sourceSpinner) { this.$refs.sourceSpinner.show(); }
      const searchProcessId = Math.random();
      const searchString = encodeURI(this.searchQuery);
      const page = this.perPage ? (this.offset / this.perPage + 1) : 1;
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(`${this.$config.app_api.prefix}media/documents`, {
        params: {
          search_string: searchString,
          page,
        },
      }).then((response) => {
        if (this.searchProcessId === searchProcessId) {
          const picks = Object.values(_.cloneDeep(response.data));
          this.total = response.data.meta.pagination.total;
          this.perPage = response.data.meta.pagination.per_page;
          delete picks.meta;
          this.picks = picks;
        }
        return this.$apiHttp.get(`${this.$config.app_api.prefix}editors-picks?type=media_doc`);
      }).then((response) => {
        if (this.searchProcessId === searchProcessId) {
          this.selectedPicksSet = new Set(response.data);
        }
        if (this.$refs.sourceSpinner) { this.$refs.sourceSpinner.hide(); }
      }).catch((error) => {
        if (this.$refs.sourceSpinner) { this.$refs.sourceSpinner.hide(); }
        console.error(error);
      });
    },
    changePage(offset) {
      this.offset = offset;
    },
    unpickRequest() {
      const postFormData = new FormData();
      postFormData.append('alias', 'media_doc');
      for (let i = 0; i < this.unpickedPicks.length; i += 1) {
        postFormData.append('ids[]', this.unpickedPicks[i].id);
      }
      return this.$apiHttp.post(
        `${this.$config.app_api.prefix}editors-picks/unpick`,
        postFormData,
      );
    },
    pickRequest() {
      const postFormData = new FormData();
      postFormData.append('alias', 'media_doc');
      for (let i = 0; i < this.selectedPicks.length; i += 1) {
        postFormData.append('ids[]', this.selectedPicks[i].id);
      }
      return this.$apiHttp.post(
        `${this.$config.app_api.prefix}editors-picks/pick`,
        postFormData,
      );
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      const promises = [];
      if (this.unpickedPicks.length) {
        promises.push(this.unpickRequest());
      }
      if (this.selectedPicks.length) {
        promises.push(this.pickRequest());
      }
      Promise.all(promises)
        .then(() => {
          this.successSave();
          this.$forceUpdate();
        }).catch((error) => {
          this.errorSave('Error in data saving');
          console.error('Error in saving picks for media/documents', error);
        });
    },
    successSave() {
      $('.btn-success .btn-loader').hide();
      $('.saving-alerts .alert-success').show();
    },
    errorSave(errorMessage) {
      $('.btn-success .btn-loader').hide();
      this.saveErrorMessage = errorMessage;
      $('.saving-alerts .alert-danger').show();
    },
    onPageChanged(offset) {
      this.offset = offset;
    },
    adaptText(text) {
      if (!text) {
        return text;
      }
      const fixedText = text.replace(/<[^>]*>/gm, '');
      if (fixedText.length > 253) {
        return `${fixedText.substring(0, 250)}...`;
      }
      return fixedText;
    },
  },
};
</script>



// WEBPACK FOOTER //
// EditorsPicksEditDocuments.vue?e683f810